export class DeleteTaskCommentInputDto {
    taskCommentId: string;
}
